export default __webpack_public_path__ + "static/media/ad.25ac0ed2.svg";